export default {
    promotions: {
        name: 'โปรโมชัน',
        fields: {
            name: 'โปรโมชัน',
            title_th: 'ชื่อโปรโมชันภาษาไทย',
            title_en: 'ชื่อโปรโมชันภาษาอังกฤษ',
            title: 'ชื่อโปรโมชัน (ไทย/อังกฤษ)',
            description: 'คำอธิบาย',
            description_th: 'คำอธิบายภาษาไทย',
            description_en: 'คำอธิบายภาษาอังกฤษ',
            short_description: 'คำอธิบาย(ย่อ)',
            short_description_th: 'คำอธิบายภาษาไทย(ย่อ)',
            short_description_en: 'คำอธิบายภาษาอังกฤษ(ย่อ)',
            start: 'เริ่มต้น',
            end: 'สิ้นสุด',
            clear: 'ล้างค่า',
            thumbnail_path_helper: 'รูปภาพตัวอย่าง',
            images_helper: 'อนุญาตเฉพาะไฟล์สกุล jpg, png, jpeg ขนาดไม่เกิน 5mb สูงสุด 15 ไฟล์',
            no_image: 'ไม่มีรูปภาพ',
            // note: 'โปรโมชั่นของคุณจะยังไม่ถูกเผยแพร่จนกว่าจะได้รับการอนุมัติ',
            note: '',
            images: {
                label: 'แกลลอรี่รูปภาพ',
                notfound: 'ไม่มีรูปภาพในแกลลอรี่'
              },
            thumbnail: {
                label: 'รูป Thumbnail',
                notfound: 'ไม่มีรูป Thumbnail'
              },
            max_card: {
                label: 'Max Card',
                choices: {
                  true: 'ใช่',
                  false: 'ไม่',
                },
            },
            credit_card: {
                label: 'Credit Card',
                choices: {
                  true: 'ใช่',
                  false: 'ไม่',
                },
            },
        },
        create: {
          title: 'สร้างโปรโมชัน',
        },
        edit: {
          title: 'แก้ไขโปรโมชัน',
        },
        banners: {
          name: 'โปรโมชันแบนเนอร์',
          fields: {
            target_link: {
              label: 'ลิงค์เป้าหมาย',
              choices: {
                promotion: 'โปรโมชัน',
                external_browser: 'เบราว์เซอร์ภายนอก',
              },
            },
          },
          create: {
            title: 'สร้างโปรโมชันแบนเนอร์',
          },
          edit: {
            title: 'แก้ไขโปรโมชันแบนเนอร์',
          },
        },
    }
}